import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import { useStore } from "../stores/store";
// import { useTranslation } from "react-i18next";
const NotFound = () => {
  const { mainStore } = useStore();
  // const { t } = useTranslation();
  useEffect(() => {
    //mainStore.setMenuType(-1);
    mainStore.setMenuNo(-1);
    // eslint-disable-next-line
  }, [mainStore]);
  return (
    <div className="d-flex">
      <div className="content p-4">
        <h4 style={{color:"red"}}>NotFound</h4>
      </div>
    </div>
  );
};

export default NotFound;
